import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ArchiveFileRequest {
  bucketName: string;
  sourceKey: string;
  reason: string;
  version: string;
}

interface ArchiveFileState {
  loading: boolean;
  error: string | null;
}

const initialState: ArchiveFileState = {
  loading: false,
  error: null,
};

const archiveFileSlice = createSlice({
  name: "archiveFile",
  initialState,
  reducers: {
    archiveFileRequest: (state, _action: PayloadAction<ArchiveFileRequest>) => {
      state.loading = true;
      state.error = null;
    },
    archiveFileSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    archiveFileFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const archiveFileActions = archiveFileSlice.actions;
export const archiveFileReducer = archiveFileSlice.reducer;